export class UserActiveDirectoryIdentityDetailData {
    directoryName: string;
    distinguishedName: string;
    userPrincipal: string;
    commonName: string;
    memberOf: [];
}
